export default function Specs({ p, compact }) {
  const items = [];
  if (p.type === 'terreno') {
    items.push(['🏛', p.totalArea + ' m²', 'lote']);
  } else {
    if (p.rooms > 0)    items.push(['amb', p.rooms,    'amb']);
    if (p.bedrooms > 0) items.push(['dorm', p.bedrooms, 'dorm']);
    if (p.bathrooms > 0) items.push(['baño', p.bathrooms, 'baño']);
    items.push(['m²', p.coveredArea || p.totalArea, 'm²']);
    if (p.parkingSpaces > 0 && !compact) items.push(['coch', p.parkingSpaces, 'coch']);
  }
  return (
    <div className={"specs" + (compact ? " specs-compact" : "")}>
      {items.map(([, v, l], i) => (
        <span key={i} className="spec" title={l}><b className="tnum">{v}</b><i>{l}</i></span>
      ))}
    </div>
  );
}
